function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1667 11.7331C13.5197 11.7331 15.4333 13.6467 15.4333 15.9998H14.3667C14.3667 14.2355 12.9309 12.7998 11.1667 12.7998H4.76667C3.0024 12.7998 1.56667 14.2355 1.56667 15.9998H0.5C0.5 13.6467 2.4136 11.7331 4.76667 11.7331H11.1667ZM8.244 0C10.4435 0 12.2333 1.7888 12.2333 3.98933V6.67733C12.2333 8.8768 10.4435 10.6667 8.244 10.6667H7.68933C5.48987 10.6667 3.7 8.8768 3.7 6.67733V3.98933C3.7 1.7888 5.48987 0 7.68933 0H8.244ZM8.244 1.06667H7.68933C6.0776 1.06667 4.76667 2.3776 4.76667 3.98933V6.67733C4.76667 8.288 6.0776 9.6 7.68933 9.6H8.244C9.85573 9.6 11.1667 8.288 11.1667 6.67733V3.98933C11.1667 2.3776 9.85573 1.06667 8.244 1.06667Z",
  fill: "currentColor"
});

var SvgAvatarIcon = function SvgAvatarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AvatarIcon.5164da15.svg";
export { ForwardRef as ReactComponent };